module.exports = __webpack_public_path__ + "img/image3.ea470a8b.png";